import type { Brand, Zone } from '@seek/audience-zones';
import type { Country, SiteName } from '@seek/melways-sites';

export enum PageUpdateActionType {
  SET_CHANGE_PASSWORD_SUCCESS = 'SET_CHANGE_PASSWORD_SUCCESS',
  SET_CHANGE_EMAIL_SUCCESS = 'SET_CHANGE_EMAIL_SUCCESS',
  SET_DELETE_ACCOUNT_SUCCESS = 'SET_DELETE_ACCOUNT_SUCCESS',
  SET_BRAND_COUNTRY_ZONE = 'SET_BRAND_COUNTRY_ZONE',
}

export interface PageAction {
  type: PageUpdateActionType;
  payload?: any;
}

export const updatePageBrandCountryZone = (
  country: Country,
  brand: Brand,
  zone: Zone,
  site: SiteName,
) => ({
  type: PageUpdateActionType.SET_BRAND_COUNTRY_ZONE,
  payload: {
    country,
    brand,
    zone,
    site,
  },
});
